import { Messages } from '../../../../codegen/Localize';
import { ServerSettingsUnauthenticated } from '../../../../settings/services/ServerSettingsUnauthenticated';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IServerUserInfo } from '../../../../ts/models/IServerUserInfo';
import { serverUserForcePasswordUpdate } from '../../../actions/spaces/ServerUserMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleSelectServerUserGuest } from './IEntityActionHelpers';

export const ServerUserForcePasswordupdateAction: IEntityAction<IServerUserInfo, {}> = {
  name: EntityActionNames.ServerUserForcePasswordReset,
  translateName: Messages.forcePasswordUpdate_action,
  isVisible: (_targetItems: IServerUserInfo[], _state: AppState) => {
    return FeatureFlags.localAuthPasswordExpirationEnabled && ServerSettingsUnauthenticated.isServerDomainFamilyLocal();
  },
  isClickable: (_availableActions: {}, targetItems: IServerUserInfo[], _state: AppState) => {
    return targetItems.length > 0 && !isSingleSelectServerUserGuest(targetItems);
  },
  createReduxAction: (targetItems: IServerUserInfo[]) => serverUserForcePasswordUpdate(targetItems)
};
